/* eslint-disable ember/classic-decorator-hooks */
import Startup from '@linc-technologies/linced-common/routes/startup';
import { service } from '@ember/service';

export default class ApplicationRoute extends Startup {
  // Services
  @service
  permissions;

  @service
  router;

  @service
  session;

  @service
  store;

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      // transition.to can be null when a transition is aborted (e.g. during
      // the OAuth callback flow), so guard against that before traversing.
      if (!transition.to) {
        return;
      }
      transition.to.find((route) => {
        // Whenever we transition between routes (including manual URL changes),
        // check the permissions to access the route
        this.checkRouteAccess(route);
      });
    });
  }

  checkRouteAccess(route) {
    let appController = this.controllerFor('application');
    // If a route is nested, check the highest level route,
    // so we don't have to specify all routes' names
    let routeName = route.name.split('.')[0];
    if (routeName === 'auth') {
      // The permissions for these subroutes are more
      // specific, use them instead of the parent route
      routeName = route.name;
    }
    switch (routeName) {
      // Universal routes
      case 'application':
      case 'callback':
      case 'home':
      case 'index':
      case 'logged-out':
      case 'login':
      case 'login-failed':
      case 'my-profile':
      case 'school-switching':
      case 'springboard':
        // Allow access to these routes for any user
        // who has access to the app, and let other code handle them
        break;
      // Hero Communication section
      case 'hero-notices':
      case 'school-groups':
        if (!appController.get('showCommunicationMenu')) {
          // No permissions to access the "Hero Communication" section
          this.router.replaceWith('access-denied');
        }
        break;
      // SuperHero Management section
      case 'sif':
      case 'cron':
      case 'finance':
      case 'auth.clients':
        if (!appController.get('showSuperMenu')) {
          // No permissions to access the "SuperHero Management"
          // and "Auth - OAuth Clients" section and menu items
          this.router.replaceWith('access-denied');
        }
        break;
      case 'auth.fusionauth':
        if (!appController.get('isSuperAdmin')) {
          // No permissions to access the "FusionAuth" section under
          // "SuperHero Management"
          this.router.replaceWith('access-denied');
        }
        break;
      default:
        // Check for at least access to the Hero Management section
        // which has the most routes
        if (!appController.get('showManagementMenu')) {
          // No permissions to access the "Hero Management" section
          this.router.replaceWith('access-denied');
        }
        break;
    }
  }
}
